/* eslint-disable @typescript-eslint/no-explicit-any */
import { baseApi } from "./baseApi";
import { ClientsSuppliersData, ClientsSuppliersResponse } from "../types/response";

const proveedoresClientes = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getClientsSuppliersByRfc: build.query<ClientsSuppliersData, string>({
      query: (rfc) => ({
        url: `sat_core/clients_and_suppliers/${rfc}`,
        method: "GET",
      }),
      transformResponse: (response: ClientsSuppliersResponse) => {
        return response.data;
      },
    }),
  }),
});

export const { useLazyGetClientsSuppliersByRfcQuery, useGetClientsSuppliersByRfcQuery } = proveedoresClientes;
